import {ContentfulFeaturedBento} from '@github-ui/swp-core/components/contentful/ContentfulFeaturedBento'
import {ContentfulRiver} from '@github-ui/swp-core/components/contentful/ContentfulRiver'
import type {FeaturedBentoType} from '@github-ui/swp-core/schemas/contentful/contentTypes/featuredBento'
import type {PrimerComponentRiver} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentRiver'

import {Section} from '../../../../../brand/components/BrandPage'
import type {GenericGroup, GenericSectionWithIds} from '../../../../../brand/lib/types/contentful'

import styles from './WorkflowSection.module.css'

type Props = {
  contentfulContent: GenericSectionWithIds
}

export function WorkflowSection(props: Props) {
  const {contentfulContent} = props
  const {sectionIntro, content} = contentfulContent.fields

  const {featuresCopilotWorkflowRivers} = contentfulContent.ids as {
    featuresCopilotWorkflowRivers: GenericGroup
  }

  const bento = content?.find(item => item.sys.contentType.sys.id === 'featuredBento') as FeaturedBentoType | undefined

  return (
    <Section introComponent={sectionIntro}>
      {featuresCopilotWorkflowRivers ? (
        <div className={styles.rivers}>
          {(featuresCopilotWorkflowRivers.fields.content as PrimerComponentRiver[]).map(riverItem => (
            <ContentfulRiver key={riverItem.sys.id} component={riverItem} />
          ))}
        </div>
      ) : null}

      {bento ? <ContentfulFeaturedBento component={bento} className={styles.bento} /> : null}
    </Section>
  )
}

try{ WorkflowSection.displayName ||= 'WorkflowSection' } catch {}